'use strict';

module.exports = {
    createEnum: require('./createEnum'),
    instanceOfEnum: require('./instanceOfEnum'),
};
